export default class MessageLogger {
	constructor(maxMessagesToStore, maxMessagesSent) {
		this.queue = [];
		this.maxMessagesToStore = maxMessagesToStore;
		this.maxMessagesSent = maxMessagesSent;
	}

	get dump() {
		return this.queue.slice(0, this.maxMessagesSent);
	}

	get fullDump() {
		return JSON && JSON.stringify ? JSON.stringify({ queue: this.queue }) : this.queue.join('\n');
	}

	logMessage(message) {
		this.queue.unshift(message);

		if (this.queue.length > this.maxMessagesToStore) {
			this.queue = this.queue.slice(0, this.maxMessagesToStore);
		}
	}
}
